import React from 'react';
import { Particles } from './animations/Particles';
import { Beams } from './animations/Beams';
import { Squares } from './animations/Squares';
import { Threads } from './animations/Threads';
import { OrbitField } from './animations/OrbitField';
import { Lightning } from './animations/Lightning';
import { Waves } from './animations/Waves';
import { Aurora } from './animations/Aurora';
import { Hyperspeed } from './animations/Hyperspeed';
import { MatrixRain } from './animations/MatrixRain';
import { RippleGrid } from './animations/RippleGrid';
import { GlowOrbs } from './animations/GlowOrbs';
import { Spotlight } from './animations/Spotlight';
import { Constellation } from './animations/Constellation';
import { CircuitGrid } from './animations/CircuitGrid';
export type FxVariant =
// primitives
'particles' | 'beams' | 'squares' | 'threads' | 'orbit' | 'orbit-left' | 'orbit-right' | 'lightning' | 'waves' | 'aurora'
// dramatic ReactBits-style
| 'hyperspeed' | 'matrix' | 'ripple' | 'glow-orbs' | 'spotlight' | 'constellation' | 'circuit'
// composed
| 'aurora-particles' | 'beams-squares' | 'matrix-aurora' | 'orbs-spotlight' | 'hyperspeed-aurora' | 'none';
interface SectionFxProps {
  variant: FxVariant;
  className?: string;
}
export function SectionFx({
  variant,
  className = ''
}: SectionFxProps) {
  return <div className={`absolute inset-0 pointer-events-none ${className}`} data-id="element-1320">
      {/* === Primitives === */}
      {variant === 'particles' && <Particles count={70} data-id="element-1321" />}
      {variant === 'beams' && <Beams count={6} data-id="element-1322" />}
      {variant === 'squares' && <Squares lit={14} data-id="element-1323" />}
      {variant === 'threads' && <Threads count={7} data-id="element-1324" />}
      {variant === 'orbit' && <OrbitField center={{
      x: 50,
      y: 50
    }} size={500} data-id="element-1325" />}
      {variant === 'orbit-left' && <OrbitField center={{
      x: 15,
      y: 50
    }} size={420} count={3} data-id="element-1326" />}
      {variant === 'orbit-right' && <OrbitField center={{
      x: 85,
      y: 50
    }} size={420} count={3} data-id="element-1327" />}
      {variant === 'lightning' && <Lightning interval={3} data-id="element-1328" />}
      {variant === 'waves' && <Waves count={4} data-id="element-1329" />}
      {variant === 'aurora' && <Aurora intensity={0.25} data-id="element-1330" />}

      {/* === Dramatic === */}
      {variant === 'hyperspeed' && <>
          <Aurora intensity={0.18} data-id="element-1331" />
          <Hyperspeed count={180} data-id="element-1332" />
        </>}
      {variant === 'matrix' && <>
          <Aurora intensity={0.18} data-id="element-1333" />
          <MatrixRain density={0.7} data-id="element-1334" />
        </>}
      {variant === 'ripple' && <>
          <Aurora intensity={0.18} data-id="element-1335" />
          <RippleGrid rows={9} cols={16} data-id="element-1336" />
        </>}
      {variant === 'glow-orbs' && <GlowOrbs count={6} data-id="element-1337" />}
      {variant === 'spotlight' && <>
          <Aurora intensity={0.18} data-id="element-1338" />
          <Spotlight data-id="element-1339" />
        </>}
      {variant === 'constellation' && <>
          <Aurora intensity={0.15} data-id="element-1340" />
          <Constellation nodes={55} linkDistance={0.18} data-id="element-1341" />
        </>}
      {variant === 'circuit' && <>
          <Aurora intensity={0.15} data-id="element-1342" />
          <CircuitGrid rows={5} cols={9} data-id="element-1343" />
        </>}

      {/* === Composed === */}
      {variant === 'aurora-particles' && <>
          <Aurora intensity={0.2} data-id="element-1344" />
          <Particles count={50} data-id="element-1345" />
        </>}
      {variant === 'beams-squares' && <>
          <Squares lit={10} data-id="element-1346" />
          <Beams count={4} data-id="element-1347" />
        </>}
      {variant === 'matrix-aurora' && <>
          <Aurora intensity={0.3} data-id="element-1348" />
          <MatrixRain density={0.5} data-id="element-1349" />
        </>}
      {variant === 'orbs-spotlight' && <>
          <GlowOrbs count={4} data-id="element-1350" />
          <Spotlight size={600} data-id="element-1351" />
        </>}
      {variant === 'hyperspeed-aurora' && <>
          <Aurora intensity={0.25} data-id="element-1352" />
          <Hyperspeed count={140} speed={0.7} data-id="element-1353" />
        </>}

      {/* Vignette to keep content readable */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, transparent 30%, rgba(5,6,8,0.55) 90%)'
    }} data-id="element-1354" />
    </div>;
}